import numeral from 'numeral';
import { currencyConfig } from '../config/currencyConfig';

// ----------------------------------------------------------------------

export function fNumber(number) {
    return numeral(number).format('0,0');
}

export function fCurrency(number) {
    return numeral(number).format('0.00');
}
export function formatCurrency(amount, currencyCode) {
    const config = currencyConfig[currencyCode];

    if (!config) {
        return fCurrency(amount);
    }

    // add symbol
    return config.format.replace('%s', config.symbol).replace('%v', fCurrency(amount));

}

export function currencyToCents(number) {
    return number ? numeral(Number(number)).multiply(100).value() : '';
}

export function fPercent(number) {
    const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

    return result(format, '.0');
}

export function fShortenNumber(number) {
    const format = number ? numeral(number).format('0.00a') : '0';

    return result(format, '.00');
}

export function fData(number) {
    const format = number ? numeral(number).format('0.0 b') : '';

    return result(format, '.0');
}

function result(format, key = '.00') {
    const isInteger = format.includes(key);

    return isInteger ? format.replace(key, '') : format;
}

